// extracted by mini-css-extract-plugin
export var filterIncDec = "_9x-0";
export var leftBorder = "_9x-1";
export var rightBorder = "_9x-2";
export var stringInput = "_9x-3";